import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { FACTS_ANIMATION_MS } from "./animation-config.js";

gsap.registerPlugin(ScrollTrigger);

const SPIN_CYCLES = 2;
const ANIMATION_MS = FACTS_ANIMATION_MS;

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

function createDigitColumn(targetDigit, columnIndex) {
  const wrapper = document.createElement("span");
  wrapper.className = "facts__digit";

  const track = document.createElement("span");
  track.className = "facts__digit-track";
  track.style.transitionDuration = `${ANIMATION_MS}ms`;

  const cycles = SPIN_CYCLES + columnIndex;

  for (let cycle = 0; cycle < cycles; cycle += 1) {
    for (let digit = 0; digit <= 9; digit += 1) {
      const cell = document.createElement("span");
      cell.className = "facts__digit-cell";
      cell.textContent = String(digit);
      track.appendChild(cell);
    }
  }

  for (let digit = 0; digit <= targetDigit; digit += 1) {
    const cell = document.createElement("span");
    cell.className = "facts__digit-cell";
    cell.textContent = String(digit);
    track.appendChild(cell);
  }

  wrapper.appendChild(track);

  return {
    wrapper,
    track,
    finalIndex: cycles * 10 + targetDigit,
  };
}

function animateFactsValue(element) {
  const value = element.dataset.factsValue || "";

  if (value === "") {
    return;
  }

  element.textContent = "";
  element.classList.add("facts__value--slot");

  const columns = [];
  let digitIndex = 0;

  [...value].forEach((character) => {
    if (/\d/.test(character)) {
      const column = createDigitColumn(Number(character), digitIndex);
      digitIndex += 1;
      element.appendChild(column.wrapper);
      columns.push(column);
      return;
    }

    const characterElement = document.createElement("span");
    characterElement.className = "facts__char";
    characterElement.textContent = character;
    element.appendChild(characterElement);
  });

  if (!columns.length) {
    element.textContent = value;
    element.classList.remove("facts__value--slot");
    return;
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      columns.forEach(({ track, finalIndex }) => {
        track.style.transform = `translateY(-${finalIndex}em)`;
      });
    });
  });
}

function initFactsSection(section) {
  const values = [
    ...section.querySelectorAll(".facts__value[data-facts-value]"),
  ];

  if (!values.length || reducedMotion) {
    return;
  }

  ScrollTrigger.create({
    trigger: section,
    start: "top 70%",
    once: true,
    onEnter: () => {
      values.forEach((element) => {
        animateFactsValue(element);
      });
    },
  });
}

document.querySelectorAll(".facts").forEach(initFactsSection);

window.addEventListener(
  "load",
  () => {
    ScrollTrigger.refresh();
  },
  { once: true },
);
